import axios from 'axios'
import { useFlameStore } from '@/stores/useFlameStore'

function buildHeaders(tokenOverride) {
    const flameToken = tokenOverride || useFlameStore().flameToken
    return {
        'Content-Type': 'application/json',
        'X-Flame-Token': flameToken
    }
}

async function request(method, path, data = {}, tokenOverride = '') {
    try {
        const response = await axios({
            method,
            url: path,
            data,
            headers: buildHeaders(tokenOverride)
        })
        return { success: true, data: response.data, status: response.status }
    } catch (err) {
        const message =
            err?.response?.data?.error ||
            err?.message ||
            '⚠️ A silence answered back.'
        return { success: false, error: message, status: err?.response?.status }
    }
}

export const sacredGet = (path, tokenOverride = '') =>
    request('get', path, {}, tokenOverride)

export const sacredPost = (path, data = {}, tokenOverride = '') =>
    request('post', path, data, tokenOverride)

export const sacredPut = (path, data = {}, tokenOverride = '') =>
    request('put', path, data, tokenOverride)

export const sacredPatch = (path, data = {}, tokenOverride = '') =>
    request('patch', path, data, tokenOverride)

export const sacredDelete = (path, data = {}, tokenOverride = '') =>
    request('delete', path, data, tokenOverride)
